import { render, staticRenderFns } from "./SearchPage.vue?vue&type=template&id=9759f068&scoped=true"
import script from "./SearchPage.vue?vue&type=script&lang=js"
export * from "./SearchPage.vue?vue&type=script&lang=js"
import style0 from "./SearchPage.vue?vue&type=style&index=0&id=9759f068&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9759f068",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9759f068')) {
      api.createRecord('9759f068', component.options)
    } else {
      api.reload('9759f068', component.options)
    }
    module.hot.accept("./SearchPage.vue?vue&type=template&id=9759f068&scoped=true", function () {
      api.rerender('9759f068', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/components/SearchPage.vue"
export default component.exports